import { render, staticRenderFns } from "./OrgSettingsHelp.vue?vue&type=template&id=de63e82c&scoped=true&"
import script from "./OrgSettingsHelp.vue?vue&type=script&lang=js&"
export * from "./OrgSettingsHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de63e82c",
  null
  
)

export default component.exports